export default __webpack_public_path__ + "static/media/img_company_header10.e4a7af2b.png";